<template>
  <el-drawer title="查看" size="100%" :visible.sync="drawerVisible" :append-to-body="true" :center="true" :wrapperClosable="false" :withHeader="false">
    <div style="padding:10px 0;">
      <order-detail :orderId="order_id"></order-detail>
    </div>

    <div class="box-project">
      <div class="main-demand box-center">
        <div class="form-demand">
            <div class="box-menu">
            <el-menu :default-active="activeIndex" mode="horizontal">
              <el-menu-item index="project">工程搭建</el-menu-item>
            </el-menu>
            <div class="box-nav-more">
              <el-button type="primary" @click="closeDrawer">关闭</el-button>
              <el-button style="margin-left:50px" type="success" icon="el-icon-download" @click="excelFile(exportQuery)">导出</el-button>
            </div>
          </div>
          <el-collapse v-model="activeNames">
            <template v-for="(item,index) in applyList">
              <el-collapse-item :title="item.create_time" :name="index+''" :key="'demand'+item.id">
                <template slot="title">
                  <div class="hs-collapse-item-header" :class="{current:item.id==current}">
                    <div class="title">
                      <span class="mr8"> <i class="el-icon-d-caret"></i>{{item.create_time}}</span>
                      <el-tag type="danger" v-if="item.work_status==1">派单中</el-tag>
                    </div>
                    <div class="remind">
                      <div class="remind-item">
                        <el-button type="primary" plain v-if="item.item_check_status1>-1" @click.stop="showDrawerPass(_self, 'confirmView', 'showDrawer', [item.id,'other','control_project'])" size="mini">{{getItemCheckTitle(item.item_check_status1)}}</el-button>
                        <!-- check_status 第一个审核条件 check_status1 第一个审核条件 -->
                        <el-button type="primary" :class="{current_btn:item.id==current}" v-if="item.item_check_status1==-1" @click.stop="showDrawerPass(_self, 'editView', 'showDrawer', [item,'add'])">派发</el-button>
                        <el-button type="primary" v-if="item.item_check_status1==3" @click.stop="showDrawerPass(_self, 'editView', 'showDrawer', [item,'edit'])">驳回编辑</el-button>
                        <template v-has="[137]" v-if="item.item_check_status1==2">
                          <el-button type="primary" plain v-if="item.edit_check_status>-1" @click.stop="showDrawerPass(_self, 'confirmView', 'showDrawer', [item.id,'other','demand_tmp_edit'])" size="mini">临时－{{getItemCheckTitle(item.edit_check_status)}}</el-button>

                          <el-button type="primary" v-if="item.edit_check_status ==-1" @click.stop="showDrawerPass(_self, 'editView', 'showChange', [item,'editors'])">临时修改</el-button>
                          <el-button type="primary" v-if="item.edit_check_status==3" @click.stop="showDrawerPass(_self, 'editView', 'showChange', [item,'editors'])">临时-驳回编辑</el-button>

                        </template>
                      </div>
                    </div>
                  </div>
                </template>
                <el-form ref="form" :model="ruleForm" label-width="80px">
                  <div class="form-header">
                    <div class="form-nav">
                      <!-- <el-checkbox-group v-model="item.category_parent_ids">
                        <template v-for="(treeItem,trid) in tree">
                          <el-checkbox-button v-if="treeItem.id != 1" class="check-item" name="type" :label="treeItem.id+''" :key="trid" @click.native.prevent>
                            <span>{{ treeItem.title }}</span>
                          </el-checkbox-button>
                        </template>
                      </el-checkbox-group> -->
                    </div>
                  </div>
                  <!-- @click="submit" -->
                  <div class="selected-list">
                    <template v-for="tItem in tree">
                      <div class="selected-item" :key="tItem.id">
                        <div class="tree-title">{{tItem.title}}</div>
                        <div class="children">
                          <template v-for="child in tItem.children">
                            <div class="category-item" :key="child.id" v-if="item.addons['category_'+child.id]">
                              <div class="category-title">
                                {{child.title}}
                              </div>
                              <div class="category-rules">
                                <div class="select-item-list" v-if="item.addons['category_'+child.id] && item.addons['category_'+child.id].length>0">
                                  <div class="hs-table-pro">
                                    <div class="hs-table-row  hs-table-header">
                                      <div class="hs-table-col">结算</div>
                                      <div class="hs-table-col">供应商</div>
                                      <div class="hs-table-col">产品</div>
                                      <div class="hs-table-col">价格</div>
                                      <div class="hs-table-col" v-for="(e,v) in child.rules" :key="v">
                                        {{e.label}}
                                      </div>
                                      <div class="hs-table-col">数量</div>
                                      <div class="hs-table-col">自定义价格</div>
                                      <div class="hs-table-col">使用备注</div>
                                      <div class="hs-table-col">是否作废</div>
                                    </div>
                                    <div class="hs-table-row" v-for="(row,index) in item.addons['category_'+child.id]" :key="index">
                                      <div class="hs-table-col">
                                        <template v-if="row.settle==1">结算中</template>
                                        <template v-if="row.settle==2">结算通过</template>
                                        <template v-if="row.settle==3">结算驳回</template>
                                        <template v-if="!row.settle">待结算</template>
                                      </div>
                                      <div class="hs-table-col">
                                        {{row.supplier ? row.supplier.title : '未分配'}}
                                      </div>
                                      <div class="hs-table-col">
                                        {{row.product ? row.product.title : '未分配'}}
                                      </div>
                                      <div class="hs-table-col">
                                        {{row.product ? row.product.price : '未分配'}}
                                      </div>
                                      <template v-for="(e, f) in row">
                                        <div class="hs-table-col" :key="f" v-if="f!='invalid' &&f!='invalid_id' && f!='settle_no' &&f!='count'&& f!='settle' && f!='remark'&& f!='supplier'&& f!='price' && f!='product'&&f!='product_id' && f!='supplier_id'">
                                          {{former.getRuleLabel(e,f,child.rules)}}
                                        </div>
                                      </template>
                                      <div class="hs-table-col">{{row.count}}</div>
                                      <div class="hs-table-col">{{row.price}}</div>
                                      <div class="hs-table-col">{{row.remark}}</div>
                                      <div class="hs-table-col">
                                        <template v-if="row.invalid_id=='0'">已作废</template>
                                        <template v-if="row.invalid_id=='1'"></template>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </el-form>
              </el-collapse-item>
            </template>
          </el-collapse>

        </div>
      </div>
      <edit-view ref="editView" :parent="_self"></edit-view>
      <confirm-view ref="confirmView"></confirm-view>

    </div>
  </el-drawer>
</template>

<script>
const ruleForm = {
  count: '',
  date: ''
};

import {
  showDrawerPass,
  getItemCheckTitle
} from '@/utils/common.js';
import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
import {
  has
} from '@/utils/promissions';
import editView from './edit.vue';
import confirmView from '@/components/audit/confirm.vue';
// 订单信息
import orderDetail from '@/components/order/detail_header.vue'
export default {
  components: {
    editView,
    confirmView,
    orderDetail,
  },
  props: {
    parent: {}
  },
  data() {
    return {
      order_id: '',
      activeName: 'demand',
      ruleForm: Object.assign({}, ruleForm),
      category: [],
      categoryType: [],
      parent_id: 0,
      tree: [],
      selected: [],
      forms: {},
      module: 'wedding_demand',
      module_id: 0,
      applyList: [],
      activeNames: ['0'],
      drawerVisible: false,
      confirm: {},
      confirmStep: [],
      order: {},
      wedding: {},
      activeIndex:'project',
      delayList:[]
    }
  },
  beforeCreate() {
    this.showDrawerPass = showDrawerPass;
    this.former = former;
    this.getRuleTag = weddingUtils.getRuleTag;
    this.getItemCheckTitle = getItemCheckTitle;
  },
  methods: {
    getShowDate(options) {
      this.showDrawer(options)
    },
    showDrawer(options) {
      this.order_id = options.order_id;
      this.current = options.id;
      this.id = options.id;
      let _this = this;
      _this.drawerVisible = true;
      _this.exportQuery = {
        order_id: _this.order_id,
        type: "control_project",
      }
      let url = '/api/wedding.demand/read';
      this.$post(url, {
        order_id: options.order_id,
        id: options.id,
        type: "control_project",
      }).then(function (res) {
        let resData = res.data;
        if (Object.keys(resData.demands).length > 0) {
          _this.applyList = resData.demands;
          _this.tree = resData.tree;
          _this.getOrderDetail(options.order_id)
        }
      });
    },
    excelFile(exportQuery) {
      let _this = this;
      let url = '/api/wedding.demand/download';
      let query = exportQuery;
      this.$post(url, query).then(res => {
        if (res.code == '200') {
          let link = document.createElement('a');
          link.href = res.data.url;
          link.click();

        }
      })

    },
    // 获取婚庆订单详情
    getOrderDetail(orderId) {
      let _this = this;
      let url = '/api/plan.order/detail';
      this.$post(url, {
        order_id: orderId
      }).then(function (res) {
        if (res.code == '200') {
          _this.order = res.data.order;
          _this.wedding = res.data.wedding;
          _this.delayList= res.data.order.delayList
        }
      });
    },
    closeDrawer() {
      this.drawerVisible = false;
    },
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }
}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    display: flex;
    padding: 12px;
    border-bottom: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;
    overflow: auto;

    .form-demand {
        flex: 1;
        padding-bottom: 20px;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: 0.5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: 0.5px solid #f6f7fb;
        }

        .hs-table-col.w80 {
            flex: 0 80px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}
.box-menu {
    position: relative;
    .box-nav-more {
        position: absolute;
        right: 20px;
        top: 20px;
    }
}
</style>
